import { Icon } from '@chakra-ui/react';

const ArrowsLeftRightIcon = (props) => (
  <Icon viewBox="0 0 16 16" {...props} fill="none">
    <g id="ArrowsLeftRightIcon">
      <path d="M11 9L13 11L11 13" stroke="#8D8186" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M3 11H13" stroke="#8D8186" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M5 7L3 5L5 3" stroke="#8D8186" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M13 5H3" stroke="#8D8186" strokeLinecap="round" strokeLinejoin="round"/>
    </g>
  </Icon>
);


export default ArrowsLeftRightIcon;
